import { createSelector } from 'reselect';

const selectSession = (state) => state.session;

export const selectCurrentUser = createSelector([selectSession], (session) => session.currentUser);
